/**
 * Created by litao on 2018/10/8.
 */
import de from "element-ui/src/locale/lang/de";

export default (http) => {
    return {
        /**
         * 分页查询
         * @param data
         * @return {*}
         */
        queryByPage(data) {
            return http.json({
                url: `/sys/purchase/account/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },

        queryUserList(data) {
            return http.json({
                url: `/sys/purchase/account/queryAll`,
                data
            })
        },
        // saveInfo (data){
        //     return http.json({
        //         url: `/sys/purchase/account/save`,
        //         data
        //     })
        // },
        toggleState(data) {
            return http.json({
                url: `/sys/purchase/account/toggleState`,
                data
            })
        },
        disable(data) {
            return http.json({
                url: `/sys/purchase/account/disable`,
                data
            })
        },
        recover(data) {
            return http.json({
                url: `/sys/purchase/account/recover`,
                data
            })
        },
        saveJxs(data) {
            return http.json({
                url: `/sys/purchase/account/saveAndAccreditJxs`,
                data
            })
        },
        addUser(data) {
            return http.json({
                url: `/sys/purchase/account/addUser`,
                data
            })
        },
        delete(data) {
            return http.json({
                url: `/sys/purchase/account/delete`,
                data
            })
        },
        /**
         * 修改用户密码
         * @param data
         */
        modifyPassword(data) {
            return http.json({
                url: '/sys/purchase/account/modifyPassword',
                data
            });
        },


        saveAccountAndWarrantyCard(data) {
            return http.json({
                url: `/erp/warranty/card/saveAccountAndWarrantyCard`,
                data
            })
        },

        getInfo(data) {
            return http.json({
                url: `/sys/open/course/get?id=${data.id}`,
                data
            })
        },

        saveInfo(data) {
            return http.json({
                url: `/sys/open/course/save`,
                data
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/sysPurchase.js